import { useNavigate } from "react-router-dom";
import "./CSS/BestSller.css";
import { Link } from "react-router-dom";
import saree1 from "../SHOPE/Images/sapra 1 (2).JPG.jpeg";
import saree2 from "../SHOPE/Images/sapra 3 (3).JPG.jpeg";
import saree3 from "../SHOPE/Images/sapra 2 (2).JPG.jpeg";

import saree1Hover from "./IMAGES/sapra 1 (12).JPG.jpeg";
import saree2Hover from "./IMAGES/sapra 3 (4).JPG.jpeg";
import saree3Hover from "./IMAGES/sapra 2 (11).JPG.jpeg";


const products = [
  {
    id: 1,
    name: "Chintamani (sky blue) Nauvari Cotton Saree ",
    price: "₹ 1399",
    img: saree1,
    hoverImg: saree1Hover,
    rating: 4.8,
  },
  {
    id: 2,
    name: "Dusty Rose Shimmery Soft tissue Saree with Running blouse piece",
    price: "₹ 1699",
    img: saree2,
    hoverImg: saree2Hover,
    rating: 4.8,
  },
  {
    id: 3,
    name: "Traditional plain cotton silk Ilkal saree",
    price: "₹ 1699",
    img: saree3,
        hoverImg: saree3Hover,

    rating: 4.8,
  },
];

const Bestseller = () => {
  const navigate = useNavigate();
  return (
    <div className="bestseller-container">
      <div className="bestseller-header">
        <h1>Bestseller Sarees</h1>
<Link to="/shop" className="see-all">
  See all
</Link>      </div>

      <p className="subtitlez">
        Our most celebrated drapes, chosen time and again.
      </p>

      <div className="bestseller-product-grid">
        {products.map((item) => (
          <div className="bestseller-card" key={item.id}>
           <div className="bestseller-image-box">
<img src={item.img} alt="" className="main-img" />
<img src={item.hoverImg || item.img} alt="" className="hover-img" />
              <div className="rating"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
  <path d="M5.70654 0L7.05363 4.1459H11.4129L7.88617 6.7082L9.23325 10.8541L5.70654 8.2918L2.17983 10.8541L3.52692 6.7082L0.000204086 4.1459H4.35946L5.70654 0Z" fill="#FFB700"/>
</svg> {item.rating}</div>
              <div className="wishlist"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
  <path d="M10 17.5C10 17.5 1.875 13.125 1.875 7.96917C1.875 5.63917 3.76417 3.75 6.09417 3.75C7.85833 3.75 9.37 4.71167 10 6.25C10.63 4.71167 12.1417 3.75 13.9067 3.75C16.2358 3.75 18.125 5.63917 18.125 7.96917C18.125 13.125 10 17.5 10 17.5Z" stroke="white" strokeOpacity="0.8" strokeWidth="0.833333" strokeLinecap="round" strokeLinejoin="round"/>
</svg></div>

<button 
  className="buy-btn"
  onClick={() => navigate("/checkout")}
>
  Buy Now
</button>
          </div>

            <h3>{item.name}</h3>
            <p className="price">{item.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bestseller;